<template>
  <div>
    <h1>Structure User Administration</h1>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AdminView',
};
</script>
